import { useTranslation } from 'react-i18next';
import { FilterPopover } from 'src/components/molecules/filter-popover';
import { bookingStateColors } from 'src/features/bookings/constants/booking-state/booking-state-colors';
import { bookingStateFilterValues } from 'src/features/bookings/constants/booking-state/booking-state-filter-values';
import { bookingStateTranslations } from 'src/features/bookings/constants/booking-state/booking-state-translations';
import { BookingState } from 'src/features/bookings/types/booking-state';
import { HandleChangeFilterValue } from 'src/types/handle-change-filter-value';
import { FilterGroup } from 'src/types/interfaces/filter-group';
import { Filters } from 'src/types/interfaces/filters';
import { getSelectedFilters } from 'src/utils/filters/get-selected-filters';
import { toggleFilterItemSelection } from 'src/utils/filters/toggle-filter-item-selection';

interface Props {
  filters: Filters;
  handleChangeFilterValue: HandleChangeFilterValue;
}

export const BookingStateFilterPopover = ({
  filters,
  handleChangeFilterValue,
}: Props) => {
  const { t } = useTranslation(['bookings']);

  const filterGroup: FilterGroup<BookingState | string> = {
    id: 1,
    type: 'status',
    label: t('bookings:common.state.title'),
    singleOption: true,
    filterOperator: 'custom',
    items: [
      {
        label: t(bookingStateTranslations.BOOKED),
        value: bookingStateFilterValues.BOOKED,
        color: bookingStateColors.BOOKED,
      },
      {
        label: t(bookingStateTranslations.STARTED),
        value: bookingStateFilterValues.STARTED,
        color: bookingStateColors.STARTED,
      },
      {
        label: t(bookingStateTranslations.FINISHED),
        value: bookingStateFilterValues.FINISHED,
        color: bookingStateColors.FINISHED,
      },
      {
        label: t(bookingStateTranslations.CANCELED),
        value: bookingStateFilterValues.CANCELED,
        color: bookingStateColors.CANCELED,
      },
    ],
  };

  return (
    <FilterPopover
      title={filterGroup.label}
      withStatusBadge
      selected={getSelectedFilters(filters, filterGroup.type)}
      onChange={option => {
        toggleFilterItemSelection(
          filterGroup.type,
          option,
          filterGroup.singleOption,
          filters,
          handleChangeFilterValue,
          filterGroup.filterOperator,
        );
      }}
      options={filterGroup.items}
    />
  );
};
